// extracted by mini-css-extract-plugin
module.exports = {"root":"SensitiveAttribute_root__3Kx9w","attribute":"SensitiveAttribute_attribute__2wrn7"};